import { NotificationType } from "@enums";
import { DEFAULT_DRAWER, PanelType } from "./OrderTrackerDrawer";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const useOrderTrackerDrawer = () => {
  const location = useLocation();
  const { notificationType } = location.state || {};
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDrawerPanel, setSelectedDrawerPanel] =
    useState<PanelType>(DEFAULT_DRAWER);

  useEffect(() => {
    if (notificationType === NotificationType.NEW_COMMENT) {
      setSelectedDrawerPanel("comments");
    } else {
      setSelectedDrawerPanel("details");
    }
  }, [notificationType]);

  return {
    drawerOpen,
    setDrawerOpen,
    selectedDrawerPanel,
    setSelectedDrawerPanel,
  };
};

export default useOrderTrackerDrawer;
